export default "__VITE_ASSET__cdcfd9eb__"